/* eslint-disable */

export default {
  init() {
    $('.mobileMenuToggler').click(function() {
      $('.menu').toggleClass('--menuVisible');
      $(this).find('.fa-chevron-down').toggle();
      $(this).find('.fa-chevron-up').toggle();
    });

    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/routes/common.js